//  import { gql } from '@apollo/client'
import gql from 'graphql-tag'

export const INITIATE_RINGGIT_PAY = gql`
  mutation InitiateRinggitPay($input: RinggitPayInitiationInput!) {
    initiateRinggitPay(input: $input) {
      paymentId
      achId
      paymentRequestId
      directDebitRequestId
      paymentLink
      directDebitLink
      paymentRedirectPage
      paymentStatus
      mandateStatus
      isEmailSent
    }
  }
`

export const MUTATION_VERIFY_USER = gql`
  mutation verifyPublicCredential($input: VerifyPublicCredentialInput!) {
    verifyPublicCredential(input: $input) {
      email
      mobileNumber {
        countryCode
        number
      }
    }
  }
`
export const MUTATION_LOGIN = gql`
  mutation ssoLoginInternal($input: SSOLoginInternalInput!) {
    ssoLoginInternal(input: $input) {
      accessToken {
        token
      }
      refreshToken {
        token
      }
      salesForceAccessToken {
        token
      }
      salesForceRefreshToken {
        token
      }
      tenantIds
      responseCode
      responseMessage
    }
  }
`

export const MUTATION_THIRD_PARTY_SEND_OTP = gql`
  mutation ThirdPartySendEmailOtp($input: ThirdPartySendEmailOtpInput!) {
    thirdPartySendEmailOtp(input: $input) {
      otpToken
      message
    }
  }
`

export const MUTATION_THIRD_PARTY_VERIFY_OTP = gql`
  mutation ThirdPartyVerifyEmailOtp($input: ThirdPartyVerifyEmailOtpInput!) {
    thirdPartyVerifyEmailOtp(input: $input) {
      accessToken {
        token
        type
      }
      refreshToken {
        token
        type
      }
      salesForceAccessToken {
        token
        type
      }
      salesForceRefreshToken {
        token
        type
      }
      tenantIds
    }
  }
`

export const MUTATION_THIRD_PARTY_RESEND_OTP = gql`
  mutation ThirdPartyResendEmailOtp($input: ThirdPartySendEmailOtpInput!) {
    thirdPartyResendEmailOtp(input: $input) {
      otpToken
      message
    }
  }
`

export const MUTATION_KYC_VERIFICATION1 = gql`
  mutation ssoLoginInternal($input: SSOLoginInternalInput!) {
    ssoLoginInternal(input: $input) {
      accessToken {
        token
      }
      refreshToken {
        token
      }
      salesForceAccessToken {
        token
      }
      salesForceRefreshToken {
        token
      }
    }
  }
`
export const TRANSFORM_SLAB_RESPONSE = gql`
  mutation TransformSlabResponse($input: JSON!) {
    transformSlabResponse(input: $input) {
      id
      name
      cardSegment
      plateformFeeType
      plateformFeeName
      plateformFeeValue
      isEdited
      sellRate
      txnAmount
      capAmount
      rateType
      annualTurnover
      aggregaterKey1
      aggregaterKey3
      slabList {
        slabList {
          upperLimit
          lowerLimit
          rateType
          rate
          originalRate
          annualTurnover {
            upperLimitAmount
            lowerLimitAmount
            rateType
            rate
            capAmount
          }
        }
        mdrType
        cardNetwork
      }
    }
  }
`

export const MUTATION_CREATE_LEAD = gql`
  mutation createLead($input: CreateLeadInput!) {
    createLead(input: $input) {
      id
      modifiedAt
      status
      ownerType
    }
  }
`

export const LOGOUT = gql`
  mutation ssoLogoutInternal($input: SSOLogoutInternalInput!) {
    ssoLogoutInternal(input: $input) {
      isLoggedOut
    }
  }
`
export const CREATE_STATE = gql`
  mutation createMerchantOnboardingState($input: CreateMerchantOnboardingStateInput!) {
    createMerchantOnboardingState(input: $input) {
      isStateCreated
    }
  }
`
export const UPDATE_STATE = gql`
  mutation updateMerchantOnboardingState($input: UpdateMerchantOnboardingStateInput!) {
    updateMerchantOnboardingState(input: $input) {
      isStateUpdated
    }
  }
`

export const CREATE_DIGILOCKER_REQUEST = gql`
  mutation CreateDigiLockerRequest($input: DigiLockerCreateInput!) {
    createDigiLockerRequest(input: $input) {
      merchantPAN
      requestId
      url
      validUpto
    }
  }
`

export const REFRESH_TOKEN = gql`
  mutation ssoLoginInternal($input: SSOLoginInternalInput!) {
    ssoLoginInternal(input: $input) {
      accessToken {
        token
      }
      refreshToken {
        token
      }
      salesForceAccessToken {
        token
      }
      salesForceRefreshToken {
        token
      }
    }
  }
`
export const CREATE_MERCHANTS = gql`
  mutation CreateMerchant($input: CreateMerchantInput!) {
    createMerchant(input: $input) {
      contactId
      created
      id
      mccId
    }
  }
`

export const CREATE_MERCHANT = gql`
  mutation Mutation($input: CreateMerchantInput!) {
    createMerchant(input: $input) {
      id
      mccId
      contactId
      created
    }
  }
`

export const CREATE_VIRTUAL_STORE = gql`
  mutation createVirtualStore($input: CreateVirtualStoreInput!) {
    createVirtualStore(input: $input) {
      merchantAccountId
      virtualStoreAccountId
      accountMccId
      contactId
      leadId
    }
  }
`

export const UPDATE_VIRTUAL_STORE = gql`
  mutation updateVirtualStore($input: UpdateVirtualStoreInput!) {
    updateVirtualStore(input: $input) {
      __typename
      ... on UpdateVirtualStoreResponse {
        status
        message
        timestamp
        virtualStoreAccountId
      }
      ... on ErrorResponse {
        errorCode
        errorMessage
        timestamp
      }
    }
  }
`

export const CREATE_BILLING_ENTITY = gql`
  mutation Mutation($input: CreateBillingEntityInput!) {
    createBillingEntity(input: $input) {
      id
      isBillingEntityCreated
    }
  }
`

export const CREATE_OPPORTIUNITY = gql`
  mutation createOpportunity($input: CreateOpportunityInput!) {
    createOpportunity(input: $input) {
      id
      ownerType
    }
  }
`

export const ADD_UPDATE_PRODUCT = gql`
  mutation addProducts($input: UpdateLeadDetails!) {
    updateLead(input: $input) {
      isUpdated
    }
  }
`

export const UPDATE_SCHEDULE_DATE = gql`
  mutation updateScheduleAt($input: UpdateLeadDetails!) {
    updateLead(input: $input) {
      isUpdated
    }
  }
`

export const MUTATION_PERFORM_OCR = gql`
  mutation Mutation($input: OCRRequestInput) {
    performOCR(input: $input) {
      documentNumber
      dob
    }
  }
`

export const MUTATION_KYC_VERIFICATION = gql`
  mutation Mutation($input: KYCValidationInput) {
    performKYCRulesValidation(input: $input) {
      requestId
    }
  }
`

export const PROCESS_PANNY_DROP = gql`
  mutation processPennyDrop($input: ProcessPennyDropInput!) {
    processPennyDrop(input: $input) {
      verification
      message
      beneficiaryName
      transactionReference
    }
  }
`

export const UPDATE_BANK_ACCOUNT = gql`
  mutation UpdateBankAccount($input: UpdateBankAccountInput!) {
    updateBankAccount(input: $input) {
      isUpdated
      pennyDropSuccess
      nameMatchSuccess
      failureReason
    }
  }
`

export const MUTATION_FACE_MATCH = gql`
  mutation Mutation($input: FaceMatchInput) {
    performFaceMatch(input: $input) {
      requestId
    }
  }
`
export const MUTATION_UPDATE_LEAD = gql`
  mutation UpdateLead($input: UpdateLeadDetails!) {
    updateLead(input: $input) {
      isUpdated
    }
  }
`

export const MUTATION_CREATE_OPP_DOCUMENT = gql`
  mutation createOpportunityDocument($input: CreateOpportunityDocumentInput!) {
    createOpportunityDocument(input: $input) {
      id
    }
  }
`
export const MUTATION_CREATE_PAYMENT = gql`
  mutation createOpportunityPaymentRecord($input: CreateOpportunityPaymentRecordInput!) {
    createOpportunityPaymentRecord(input: $input) {
      id
    }
  }
`

export const UPDATE_OPP_PAYMENT = gql`
  mutation UpdateOpportunityPaymentRecord($input: UpdateOpportunityPaymentRecordInput!) {
    updateOpportunityPaymentRecord(input: $input) {
      id
    }
  }
`
export const MUTATION_UPDATE_OPP_DOC = gql`
  mutation updateOpportunityDocument($input: UpdateOpportunityDocumentInput!) {
    updateOpportunityDocument(input: $input) {
      id
    }
  }
`

export const UPDATE_MCC_DETAIL = gql`
  mutation UpdateMerchant($input: UpdateMerchantMCCInput!) {
    updateMerchantMCC(input: $input) {
      mccDataUpdated
    }
  }
`

export const UPDATE_BILLING_DETAIL = gql`
  mutation UpdateBillingEntity($input: UpdateBillingEntityInput!) {
    updateBillingEntity(input: $input) {
      isBillingEntityUpdated
    }
  }
`

export const CHECK_OSV_MUTATION = gql`
  mutation CheckOSV($input: CheckOSVInput!) {
    checkOSV(input: $input) {
      isOSV
    }
  }
`
export const UPDATE_MERCHANT = gql`
  mutation UpdateMerchant($input: UpdateMerchantInput!) {
    updateMerchant(input: $input) {
      accountDataUpdated
    }
  }
`

export const CREATE_STORE = gql`
  mutation CreateDeploymentStore($input: CreateDeploymentStoreInput!) {
    createDeploymentStore(input: $input) {
      id
      isStoreCreated
    }
  }
`

export const UPDATE_OPPORTUNITY = gql`
  mutation updateOpportunity($input: UpdateOpportunityInput!) {
    updateOpportunity(input: $input) {
      id
    }
  }
`

export const MUTATION_CREATE_MANDATE = gql`
  mutation CreateEMandate($input: EMandateInput!) {
    createEMandate(input: $input) {
      mandateStatus
      redirectUrl
      requestId
      mandateMode
    }
  }
`

export const MUTATION_CREATE_E_SIGN_MANDATE = gql`
  mutation CreateESignMandate($input: ESignMandateInput!) {
    createESignMandate(input: $input) {
      mandateStatus
      redirectUrl
      requestId
      mandateMode
    }
  }
`

export const MUTATION_UPDATE_DEPLOYMENT = gql`
  mutation processDeployment($input: ProcessDeploymentInput!) {
    processDeployment(input: $input) {
      isProcessed
    }
  }
`
export const ADD_BANK_ACCOUNT = gql`
  mutation CreateBankAccount($input: CreateBankAccountInput!) {
    createBankAccount(input: $input) {
      id
      isBankAccountCreated
      pennyDropSuccess
      nameMatchSuccess
      failureReason
    }
  }
`

export const REVIEW_OPPORTUNITY = gql`
  mutation Mutation($input: ReviewOpportunityInput!) {
    reviewOpportunity(input: $input) {
      id
    }
  }
`

export const MUTATION_CREATE_PAYMENT_LINK = gql`
  mutation InitiatePayment($input: InitiatePaymentInput!) {
    initiatePayment(input: $input) {
      payLinkUrl
      isEmailSent
      isPaymentInitiated
      paymentId
      redirectPage
    }
  }
`

export const MUTATION_UPDATE_STORE = gql`
  mutation UpdateDeploymentStore($input: UpdateDeploymentStoreInput!) {
    updateDeploymentStore(input: $input) {
      isStoreUpdated
    }
  }
`

export const UPDATE_MERCHANT_CONTACT = gql`
  mutation Mutation($input: UpdateMerchantContactInput!) {
    updateMerchantContact(input: $input) {
      contactDataUpdated
    }
  }
`
export const CREATE_P_MANDATE = gql`
  mutation CreatePMandate($input: PMandateInput!) {
    createPMandate(input: $input) {
      reference1
      redirectUrl
      mandateStatus
      mandateMode
    }
  }
`
export const UPLOAD_P_MANDATE = gql`
  mutation UploadPMandate($input: UploadPMandateInput!) {
    uploadPMandate(input: $input) {
      isUploaded
    }
  }
`

export const UPLOAD_MULTI_STORES = gql`
  mutation CreateDeploymentStores($input: CreateDeploymentStoresInput!) {
    createDeploymentStores(input: $input) {
      stores {
        id
        name
        edgeUatMid
      }
    }
  }
`

export const CREATE_SIGNATORY_INFO = gql`
  mutation CreateMerchantSignatoryInfo($input: CreateMerchantSignatoryInfoInput!) {
    createMerchantSignatoryInfo(input: $input) {
      id
    }
  }
`

export const UPDATE_SIGNATORY_INFO = gql`
  mutation UpdateMerchantSignatoryInfo($input: UpdateMerchantSignatoryInfoInput!) {
    updateMerchantSignatoryInfo(input: $input) {
      signatoryInfoUpdated
    }
  }
`
export const DELETE_SIGNATORY_INFO = gql`
  mutation DeleteMerchantSignatoryInfo($input: DeleteMerchantSignatoryInfoInput!) {
    deleteMerchantSignatoryInfo(input: $input) {
      signatoryInfoDeleted
    }
  }
`
export const UPDATE_MERCHANT_ACCOUNT = gql`
  mutation Mutation($input: UpdateMerchantContactInput!) {
    updateMerchantContact(input: $input) {
      contactDataUpdated
    }
  }
`
export const DELETE_OPPORTUNITY_DOC = gql`
  mutation DeleteOpportunityDocuments($input: DeleteOpportunityDocumentsInput!) {
    deleteOpportunityDocuments(input: $input) {
      isDeleted
    }
  }
`

export const MULTY_OPP_DOC_CREATE = gql`
  mutation createOpportunityDocuments($input: CreateOpportunityDocumentsInput!) {
    createOpportunityDocuments(input: $input) {
      documents {
        id
        name
      }
    }
  }
`
export const CREATE_MERCHANT_CONTACT = gql`
  mutation CreateMerchantContact($input: CreateMerchantContactInput!) {
    createMerchantContact(input: $input) {
      accountId
      contactId
    }
  }
`

export const CREATE_MERCHANT_CONTACT_LIST = gql`
  mutation CreateMerchantContactList($input: CreateMerchantContactListInput!) {
    createMerchantContactList(input: $input) {
      status
      contacts {
        status
        accountId
        contactId
      }
    }
  }
`
export const CREATE_MCC_ON_ACCOUNT = gql`
  mutation CreateMerchantAccountMcc($input: CreateMerchantMccInput!) {
    createMerchantAccountMcc(input: $input) {
      accountId
      mccId
    }
  }
`

export const SYNC_KYC_DATA = gql`
  mutation Mutation($input: KycDocDigitalSyncInput!) {
    performKycDocDigitalSync(input: $input) {
      success
    }
  }
`

export const DIGITALLY_EXTRACT_DOCUMENT = gql`
  mutation PerformOCRandDigitallyExtract($input: OCRRAndDigitallyExtractInput!) {
    performOCRandDigitallyExtract(input: $input) {
      requestId
      kycRefId
      extractedData {
        documentNumber
        name
        dob
        completeAddress
      }
      ocrData {
        documentNumber
        dob
        gender
        address
      }
      eExtractionSuccess
    }
  }
`

export const MUTATE_KYC_OPPORTUNITY_DOCUMENT = gql`
  mutation KycOpportunityDocument($input: KYCOpportunityDocumentInput!) {
    kycOpportunityDocument(input: $input) {
      id
      verifiedThroughOnlinePortal
      documentSubType
    }
  }
`
export const CREATE_PRODUCT_OLI = gql`
  mutation CreateOLI($input: CreateOLIsInput!) {
    createOLI(input: $input) {
      OLIs {
        id
        productName
      }
    }
  }
`
export const PRODUCT_CONSUMED = gql`
  mutation productsConsumed($input: ProductsConsumedInput!) {
    productsConsumed(input: $input) {
      id
      assetName
      acquirer
      storeName
      address {
        addressLine1
        addressLine2
        addressLine3
        area
        district
        city
        state
        country
        pincode
        latitude
        longitude
      }
      createdDate
      workFlowState
      status
      isProductsConsumed
      isLinkingDone
      cardTestTransactionApplicable
      upiTestTransactionApplicable
      linkingApplicable
    }
  }
`
export const UPDATE_PRODUCT_CONSUMED = gql`
  mutation Mutation($input: UpdateDeploymentRequestInput!) {
    updateDeploymentRequest(input: $input) {
      isUpdated
    }
  }
`

export const UPDATE_DEVICE_LINKING = gql`
  mutation deviceLinkingDetails($input: DeviceLinkingInput!) {
    deviceLinkingDetails(input: $input) {
      created
    }
  }
`

export const UPDATE_DEVICE_DELINKING = gql`
  mutation deviceDeLinkingDetails($input: DeviceLinkingInput!) {
    deviceDeLinkingDetails(input: $input) {
      created
    }
  }
`

export const CREATE_PRODUCT_TRANSFER = gql`
  mutation CreateProductTransfer($input: CreateProductTransferInput) {
    createProductTransfer(input: $input) {
      id
    }
  }
`

export const UPDATE_PRODUCT_TRANSFER = gql`
  mutation UpdateProductTransfer($input: UpdateProductTransferInput) {
    updateProductTransfer(input: $input) {
      isUpdated
    }
  }
`

export const UPDATE_STAGE_TRIGGER = gql`
  mutation PostToSfIntegration($input: sfIntegrationInput!) {
    postToSfIntegration(input: $input) {
      pushedToSf
    }
  }
`
export const CREATE_OLIS_V2 = gql`
  mutation CreateOliByAccount($input: ProductListByAccountInput!) {
    createOliByAccount(input: $input) {
      products {
        id
        sfReferenceId
        name
        advanceMonth
        posProduct {
          id
          sfReferenceId
          name
          feeMappingReference
          posType
          hardwareModel
          downstreamPosId
          edcType
          edcItemNumber
          createdOn
          modifiedOn
          createdBy
          modifiedBy
          active
        }
        vasProduct {
          id
          sfReferenceId
          downstreamVasId
          name
          aggregatorProgramId
          aggregatorProgramName
          feeMappingReference
          bankDetails
          settlementCycle
          modeOfPay
          createdOn
          modifiedOn
          createdBy
          modifiedBy
          active
          pg
          accessory
        }
        eligibleFor3PUser
        quantity
        aggregator
      }
    }
  }
`

export const GET_POS_PLAN_LIST = gql`
  mutation AllPlansByHardPos($input: PlansInput!) {
    allPlansByHardPos(input: $input) {
      plans {
        id
        sfReferenceId
        name
        description
        advanceMonth
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        hardPosInPlan
        active
        aggregator
      }
    }
  }
`
export const CREATE_OLI_BY_PLAN_ID = gql`
  mutation CreateOLIByPlan($input: createOLIByPlanInput!) {
    createOLIByPlan(input: $input) {
      products {
        id
        sfReferenceId
        name
        advanceMonth
        posProduct {
          id
          sfReferenceId
          name
          feeMappingReference
          posType
          hardwareModel
          downstreamPosId
          edcType
          edcItemNumber
          createdOn
          modifiedOn
          createdBy
          modifiedBy
          productImageUrl
          subTypeVersionId
          subTypeVersionName
          hardwareSubTypeId
          hardwareSubTypeName
          active
        }
        vasProduct {
          id
          sfReferenceId
          downstreamVasId
          name
          aggregatorProgramId
          aggregatorProgramName
          feeMappingReference
          bankDetails
          settlementCycle
          modeOfPay
          createdOn
          modifiedOn
          createdBy
          modifiedBy
          active
          pg
          accessory
        }
        fees {
          id
          sfReferenceId
          name
          fee
          feeType
          unitOfMeasurement
          value
          minValue
          maxValue
          frequency
          downStreamNBSId
          entityType
          navFeeCode
          subscription
          createdOn
          active
        }
        eligibleFor3PUser
        quantity
        aggregator
      }
    }
  }
`
export const CACHE_ACCOUNT = gql`
  mutation CacheAccount($input: CacheAccountInput!) {
    cacheAccount(input: $input) {
      isUpdated
    }
  }
`

export const SUBMIT_REVISIT_FEEDBACK = gql`
  mutation SubmitRevisitLeadFeedback($input: SubmitRevisitFeedbackInput!) {
    revisitLeadFeedback(input: $input) {
      isSubmitted
    }
  }
`

export const GENERATE_OTP = gql`
  mutation Mutation($input: GenerateOTPAllInput!) {
    generateOTPAll(input: $input) {
      maskedMobileNumber
      retryDelay
    }
  }
`
export const VERIFY_OTP = gql`
  mutation Mutation($input: validateOTPInput!) {
    validateOTPAll(input: $input) {
      accepted
    }
  }
`
export const PO_CASE_ACTION = gql`
  mutation Mutation($input: poCaseActionInput!) {
    poCaseAction(input: $input) {
      caseId
      status
      message
    }
  }
`
export const UPDATE_OLI_BY_OPPORTUNITY = gql`
  mutation UpdateOliByOpportunity($input: UpdateOliByOpportunityInput) {
    updateOliByOpportunity(input: $input) {
      message
    }
  }
`
export const UPDATE_TENTATIVE_STORE_ID = gql`
  mutation UpdateTentativeStoreId($input: UpdateTentativeStoreIdInput!) {
    updateTentativeStoreId(input: $input) {
      id
      tenantId
      crmRefId
      opportunityId
      storeId
      tentativeStoreId
      remarks
      name
      hardwareIdentifier
      posType
      posProductId
      accountId
      contactId
      assetType
      promotionType
      status
      approvalStatus
      isDeleted
      deploymentDetailId
      selfDeployment
      pushedToSF
      sequenceNumber
      hardwareSubTypeId
      hardwareSubTypeName
      subTypeVersionId
      subTypeVersionName
      posProductReferenceId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      createdBySource
      modifiedBySource
      edcNumber
    }
  }
`

export const UPDATE_SIGN_URL_BY_EMAIL = gql`
  mutation UpdateSignUrlByEmail($input: UpdateSignUrlByEmailInput!) {
    updateSignUrlByEmail(input: $input) {
      signUrlUpdated
    }
  }
`
